import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
  name: "app",
  namespaced: true
})
export class AppStore extends VuexModule {
  /**признак загрузки */
  public loading: boolean = false;

  public showCatalogOperationModal: boolean = false;

  private maskTokens: any = {
    'a': { pattern: /[a-zA-ZЁёА-я]/ },
    '9': { pattern: /\d/ },
    '?': { pattern: /\./ },
    '*': { pattern: /[0-9A-Za-zА-Яа-я]/ }
  }

  @Mutation
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  @Mutation
  setCatalogFlag(flag: boolean) {
    this.showCatalogOperationModal = flag;
  }

  get getLoading(): boolean {
    return this.loading;
  }

  get customTokens(): any {
    return this.maskTokens;
  }
}
